/**
 * IMPORTANT! Do not use any services/composables here! (other than the ones defined in the context).
 *
 * This redirect handler should be used solely to determine whether user should be redirected
 * to a certain place or not, based on the application state, which is passed into the exported
 * function as first argument.
 *
 * Only imports that help to determine the redirect are allowed here (like consts or moment).
 */
// rich text editor entrypoint for mobiles - TMP solution before microservice migration
export const richTextEditorRedirect = ({ store, router, logger, params }) => {
  if (
    params.redirection?.path === 'rich-text-editor'
    && store.state.app.webView
    && store.getters['app/isMobile']
  ) {
    logger.debug('mobile editor entrypoint path >>> rich-text-editor')
    return router.push({ name: 'rich-text-editor' })
  }
}
